import { Components } from '@/api/generated/api';
import { computed, ComputedRef, ref } from 'vue';
import { useSchoolSubjectQuery } from './schoolSubject/schoolSubject.queries';

interface ICurrentSchoolSubjectComposable {
  currentSchoolSubject: ComputedRef<Components.Schemas.SchoolSubjectDto | undefined>;
  currentSchoolSubjectTemplate: ComputedRef<Components.Schemas.SchoolSubjectDto | undefined>;
  setCurrentSchoolSubject: (schoolSubjectId?: number) => void;
}

const currentSchoolSubjectId = ref<number | undefined>(undefined);

export const setCurrentSchoolSubject = (schoolSubjectId?: number): void => {
  currentSchoolSubjectId.value = schoolSubjectId;
};

export const useCurrentSchoolSubject = (): ICurrentSchoolSubjectComposable => {
  const query = useSchoolSubjectQuery(currentSchoolSubjectId);
  const currentSchoolSubject = computed(() => (query.data.value?.isTemplate ? undefined : query.data.value));
  const currentSchoolSubjectTemplate = computed(() => (query.data.value?.isTemplate ? query.data.value : undefined));

  return {
    currentSchoolSubject,
    currentSchoolSubjectTemplate,
    setCurrentSchoolSubject,
  };
};
